<template>
  <b-modal
    :id="idDetailMessageModal"
    scrollable
    centered
    hide-footer
    size="lg"
    header-text-variant="gray1"
    header-class="pb-0 pt-1"
  >
    <h5 class="text-center mb-4">{{ title }}</h5>
    <div v-for="(msg, i) in errMsges" :key="i">
      <p class="text-break">{{ msg | replaceMsg }}</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  components: {
  },
  props: {
    errMsges: {
      type: Array
    },
    title: {
      type: String
    },
    idDetailMessageModal: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  filters: {
    replaceMsg(msg) {
      return msg ? msg.replace('<br/>', '') : msg
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.errorMessage {
  @include responsive-fs(16);
}

/deep/ .modal-header {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DetailMessageModalComponent.vue